import { PendingReason } from '../../../models/ordering/enums/pending-reason';
import { JsonProperty } from '../../../models/utilities/json-property';

/**
 * One thing the pending orders are waiting on, and how many of them wait on it
 */
export class WaitingReason {

    public pendingReason : PendingReason = PendingReason.None;

    public count : number = 0;

}

/**
 * The orders that are waiting on someone to review or release them, of the ones with a cutoff in the next few days
 */
export class WaitingOnSomeone {

    // How many days ahead of today the cutoffs are looked at
    public days : number = 0;

    // Each order once, however many things it waits on
    public total : number = 0;

    // An order that waits on two things is in two of these, so they can add up to more than the total
    @JsonProperty({ toClass: WaitingReason, designType: 'array' })
    public reasons : WaitingReason[] = [];

}
